(() => {
  if (window.__hueCartInit) return;
  window.__hueCartInit = true;

  // Optional override from theme code if you use a drawer with sections:
  // window.HUE_CART_SECTIONS = 'cart,cart-count,drawer-cart';

  const CART_SECTIONS = window.HUE_CART_SECTIONS || 'cart,cart-count';

  function openCartUI() {
    const openers = [
      "a[href='/cart']",
      "[data-cart-open]",
      ".js-drawer-open-cart",
      "[aria-controls='CartDrawer']",
      "[data-action='open-drawer'][data-drawer-id='cart']",
    ];
    for (const sel of openers) {
      const el = document.querySelector(sel);
      if (el && typeof el.click === 'function') {
        el.click();
        return;
      }
    }
    window.location.assign('/cart');
  }

  async function addToCart(variantId, quantity = 1) {
    if (!variantId) {
      console.warn('[HUE CART] Missing variantId in hue-add-to-cart event');
      return;
    }

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    formData.append('sections', CART_SECTIONS);

    const url = (window.Shopify?.routes?.root || '/') + 'cart/add.js';

    const res = await fetch(url, { method: 'POST', body: formData });
    const data = await res.json();

    // Open cart and notify theme
    openCartUI();
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));
    return data;
  }

  window.hueAddToCart = addToCart;

  document.addEventListener('hue-add-to-cart', (e) => {
    const id = e?.detail?.variantId;
    const qty = e?.detail?.quantity || 1;
    addToCart(id, qty).catch((err) => console.error('[HUE CART] addToCart failed', err));
  });
})();
